import _ from 'lodash';
import moment from 'moment';
import { PERMISSIONS } from '../constants/permissions.constants';
import { ATTACHMENT_TYPES, BFF_HOST, DOSSIER_STATUSES, DOSSIER_TYPES } from '../constants/settings.constants';
import { getToken } from '../services/session.storage';

const CAN_DELETE_CLARIFICATION_STATUSES = [
  DOSSIER_STATUSES.NEW_TRAJECT.name,
  DOSSIER_STATUSES.CLARIFIERS_ADDED.name,
  DOSSIER_STATUSES.CLARIFICATION_DATE_ADDED.name
];

const _filterAttachmentsByTypesAndRefId = (att, types = [], refId) =>
  types.includes(att.type) && att.referenceId === refId;

export const statusToString = (status) => status?.name || 'Onbekend';

export const involvedToString = (involved) =>
  `${involved?.firstName || involved?.firstname || ''} ${involved?.lastName || involved?.lastname || ''}`.trim();

export const typeToString = (type) =>
  type === DOSSIER_TYPES.PROGRAM
    ? 'Traject'
    : type === DOSSIER_TYPES.FINANCED_PROGRAM
    ? 'Traject met toelage'
    : type === DOSSIER_TYPES.ACTION
    ? 'Actie'
    : 'Onbekend';

export const branchToString = (branch) => _.uniq(branch?.map((b) => b?.name || '') ?? [])?.join(', ') ?? '';
export const schoolToString = (school) => _.uniq(school?.map((b) => b?.name || '') ?? [])?.join(', ') ?? '';
export const clarificationToTitle = (clarification) => {
  if (!clarification.date) {
    return 'Vraagverheldering';
  }

  const date = moment(clarification.date, 'DD/MM/YYYY');
  return `Vraagverheldering ${date.isValid() ? date.format('DD/MM/YYYY') : ''}`.trim();
};
export const casetafelToTitle = (casetafel) =>
  clarificationToTitle(casetafel)?.replace('Vraagverheldering', 'Casetafel');
export const commissionToTitle = (casetafel) =>
  clarificationToTitle(casetafel)?.replace('Vraagverheldering', 'Commissie');
export const procedureGoalToTitle = (goal) => `Langetermijndoel ${goal.name || ''}`.trim();
export const goalIndicatorToTitle = (indicator) =>
  procedureGoalToTitle(indicator).replace('Langetermijndoel', 'Indicator');
export const procedurePartToTitle = (part) => `Onderdeel ${part.name || ''}`.trim();

export const getAttachmentsByTypes = (attachments = [], types = []) => {
  return attachments?.filter((att) => types.includes(att.type));
};

export const getAttachmentsForRequest = (attachments) => {
  return getAttachmentsByTypes(attachments, [ATTACHMENT_TYPES.REQUEST]);
};

export const getAttachmentsForClarification = (clarification, attachments) => {
  return attachments?.filter((att) =>
    _filterAttachmentsByTypesAndRefId(att, [ATTACHMENT_TYPES.CLARIFICATION], clarification.id)
  );
};

export const getAttachmentsForContactMoment = (contactMoment, attachments) => {
  return attachments?.filter((att) =>
    _filterAttachmentsByTypesAndRefId(att, [ATTACHMENT_TYPES.CONTACT_MOMENT], contactMoment.id)
  );
};

export const getAttachmentsForCasetafel = (casetafel, attachments) => {
  return attachments?.filter((att) =>
    _filterAttachmentsByTypesAndRefId(att, [ATTACHMENT_TYPES.CASETAFEL], casetafel.id)
  );
};

export const getAttachmentsForCasetafelReport = (casetafel, attachments) => {
  return attachments?.filter((att) =>
    _filterAttachmentsByTypesAndRefId(att, [ATTACHMENT_TYPES.CASETAFEL_REPORT], casetafel.id)
  );
};

export const getAttachmentsForMeasureMoment = (measureMoment, attachments) => {
  return attachments?.filter((att) =>
    _filterAttachmentsByTypesAndRefId(att, [ATTACHMENT_TYPES.MEASURE_MOMENT], measureMoment.id)
  );
};

export const getAttachmentsForProcedure = (attachments) => {
  return attachments?.filter((att) => att.type === ATTACHMENT_TYPES.PROCEDURE);
};

export const getAttachmentsForProcedurePart = (part, attachments) => {
  return attachments?.filter((att) =>
    _filterAttachmentsByTypesAndRefId(att, [ATTACHMENT_TYPES.PROCEDURE_PART], part.id)
  );
};

export const attachmentBody = (referenceId, type, data) => ({
  ..._.pick(data, ['name', 'url', 'description', 'attachment']),
  type,
  ...(referenceId ? { referenceId } : {})
});

export const procedureAttachmentBody = (data) => ({
  ..._.pick(data, ['name', 'url', 'description', 'attachment']),
  type: ATTACHMENT_TYPES.PROCEDURE
});

export const canDeleteClarification = (status, userRoles = []) =>
  CAN_DELETE_CLARIFICATION_STATUSES.includes(status) &&
  (userRoles.includes(PERMISSIONS.STAD_DISPATCH) || userRoles.includes(PERMISSIONS.STAD_ADMIN));
export const canAddClarification = canDeleteClarification;

export const getDossierAttachmentLink = (dossierId, attachment) => {
  return `${BFF_HOST[process.env.NODE_ENV] || window.location.origin}/api/dossiers/${dossierId}/attachments/${
    attachment.id
  }?filename=${attachment.fileName || ''}&token=${getToken()}`;
};
